import React from 'react';
import PropTypes from 'prop-types';
import ProjectSelector from './ProjectSelector';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import SearchDialog from '../search/SearchDialog';
import BoardList from './BoardList';
import OverlayController from "../overlay/OverlayController";
import CreateItemDialog from '../item/CreateItemDialog';
import PluginsManager from '../plugins/PluginsManager';
import queries from '../../graphql/queries';
import paths from '../../services/paths';
import { Link } from 'react-router';
import { GraphQLStackTrace } from '../../utils/utils'
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import './Sidebar.css';

class Sidebar extends React.Component {

    constructor(props) {
        super(props);

        this.configureButtons(props);
    }

    componentWillReceiveProps(nextProps) {
        this.configureButtons(nextProps);
    }

    configureButtons(props) {
        this.buttonsConfig = [{
            path: paths.settings(props.projectId),
            label: "Settings",
            icon: "settings"
        }, {
            path: paths.workflow(props.projectId),
            label: "Workflow",
            icon: "device_hub"
        }, {
            path: paths.plugins(props.projectId),
            label: "Plugins",
            icon: "widgets"
        }, {
            path: paths.analytics(props.projectId),
            label: "Analytics",
            icon: "show_chart"
        }, {
            path: paths.webhooks(props.projectId),
            label: "Webhooks",
            icon: "input"
        }];
    }

    onSearchClick(event) {
        OverlayController.showOverlay({
            component: <SearchDialog  project={this.props.data.project}/>,
            className: 'searchDialogOverlay mdc-elevation--z24'
        });
    }

    onCreateItemClick(event) {
        OverlayController.showOverlay({
            component: <CreateItemDialog  project={this.props.data.project}/>,
            className: 'createItemDialogOverlay'
        });
    }

    renderNavigationList() {
        let buttonList = this.buttonsConfig.map(buttonConfig => {
            let onClick;
            let href;
            if (buttonConfig.path) {
                href = buttonConfig.path;
            }
            if (buttonConfig.onClick) {
                onClick = buttonConfig.onClick;
            }
            return (
                <FlatButton className="sidebarListItemButton" containerElement={<div/>} fullWidth={true} key={buttonConfig.label}>
                    <Link to={href} onClick={onClick} activeClassName="active" className="materialListItem singleLine">
                        <i className="materialListItemLeftIcon material-icons">{buttonConfig.icon}</i>
                        <span className="materialListItemText">{buttonConfig.label}</span>
                    </Link>
                </FlatButton>
            );
        });
        return (
            <div className="materialList dense navigationItemList">
                {buttonList}
            </div>
        )
    }

    renderItemList() {
        let createItemButton = null;
        if (this.hasPluginItemCreateViewPlugin()) {
            createItemButton = (
                <FlatButton className="sidebarListItemButton" containerElement={<div/>} fullWidth={true} onTouchTap={(event) => { this.onCreateItemClick(event); }}>
                    <div className="materialListItem singleLine">
                        <i className="materialListItemLeftIcon material-icons">add</i>
                        <span className="materialListItemText">Create Item</span>
                    </div>
                </FlatButton>
            );
        }
        return (
            <div className="materialList dense">
                <div className="materialListItem materialListSubheader">
                    <div className="materialListItemText">Items</div>
                </div>
                <FlatButton className="sidebarListItemButton" containerElement={<div/>} fullWidth={true} onTouchTap={(event) => { this.onSearchClick(event); }} >
                    <div className="materialListItem singleLine">
                        <i className="materialListItemLeftIcon material-icons">search</i>
                        <span className="materialListItemText">Search</span>
                    </div>
                </FlatButton>
                {createItemButton}
            </div>
        );
    }

    hasPluginItemCreateViewPlugin() {
        return this.props.data.project.plugins.some(plugin => {
            return 'PluginItemCreateView' in PluginsManager.getPluginByTypeId(plugin.typeId);
        });
    }

    render() {
        let content = null;
        if (this.props.data.loading || this.props.projectListData.loading) {
            content = <CircularProgress className="activityIndicator"/>;
        } else if (this.props.data.error || this.props.projectListData.error) {
            content = <pre>{GraphQLStackTrace(this.props.data.error || this.props.projectListData.error)}</pre>;
        } else {
            content = (
                <div>
                    <ProjectSelector project={this.props.data.project} projectList={this.props.projectListData.projects}/>
                    {this.renderNavigationList()}
                    <BoardList project={this.props.data.project} />
                    {this.renderItemList()}
                </div>
            );
        }
        return (
            <div className="projectSidebar">{content}</div>
        );
    }

}

Sidebar.propTypes = {
    projectId: PropTypes.string.isRequired,
    projectListData: PropTypes.object.isRequired
};

export default compose(
    queries.projectQueryHoc,
    queries.projectsQueryHocWithName('projectListData')
)(withRouter(Sidebar));




// WEBPACK FOOTER //
// ./src/components/sidebar/Sidebar.js